import { useState, useCallback } from 'react';
import { TRIVIA_GENERAL } from '../data/trivia';
import { TRIVIA_ROVERS } from '../data/trivia';
import { TRIVIA_FOREST } from '../data/trivia';
function shuffle(a){const b=[...a];for(let i=b.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[b[i],b[j]]=[b[j],b[i]];}return b;}
const BANKS={general:{label:'World Cup General',emoji:'🌍',data:TRIVIA_GENERAL},rovers:{label:'Blackburn Rovers',emoji:'🔵⚪',data:TRIVIA_ROVERS},forest:{label:'Nottingham Forest',emoji:'🔴⚪',data:TRIVIA_FOREST}};
export default function PubQuizHost({onBack}){
  const [phase,setPhase]=useState('setup');
  const [teams,setTeams]=useState([{name:'Team 1'},{name:'Team 2'}]);
  const [bank,setBank]=useState('general');
  const [qCount,setQCount]=useState(10);
  const [qs,setQs]=useState([]);
  const [qi,setQi]=useState(0);
  const [scores,setScores]=useState({});
  const [revealed,setRevealed]=useState(false);
  const [marked,setMarked]=useState({});
  const updateTeam=(i,v)=>setTeams(t=>{const n=[...t];n[i]={name:v};return n;});
  const addTeam=()=>{if(teams.length<8)setTeams(t=>[...t,{name:'Team '+(t.length+1)}]);};
  const removeTeam=(i)=>setTeams(t=>t.filter((_,j)=>j!==i));
  const startQuiz=useCallback(()=>{
    const q=shuffle(BANKS[bank].data).slice(0,qCount);
    const sc={};teams.forEach(t=>{sc[t.name]=0;});
    setQs(q);setQi(0);setScores(sc);setRevealed(false);setMarked({});setPhase('quiz');
  },[bank,qCount,teams]);
  const revealAnswer=()=>setRevealed(true);
  const mark=(teamName,correct)=>{
    setMarked(m=>({...m,[teamName]:correct?'correct':'wrong'}));
    if(correct)setScores(s=>({...s,[teamName]:s[teamName]+1}));
  };
  const nextQ=useCallback(()=>{
    if(qi+1>=qs.length){setPhase('over');return;}
    setQi(qi+1);setRevealed(false);setMarked({});
  },[qi,qs]);
  const sorted=Object.entries(scores).sort((a,b)=>b[1]-a[1]);
  const q=qs[qi];
  return(<div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className="g-title" style={{color:'#facc15'}}>PUB QUIZ HOST</div>
      {phase==='quiz'&&<div className="g-pills">
        <div className="g-pill yy"><span className="g-plbl">Q</span><span className="g-pval">{qi+1}/{qs.length}</span></div>
      </div>}
    </div>
    {phase==='setup'&&<div className="pq-setup">
      <div>
        <div className="pq-section">Teams (up to 8)</div>
        {teams.map((t,i)=><div key={i} className="pq-team-row" style={{marginBottom:6}}>
          <input className="pq-team-input" value={t.name} onChange={e=>updateTeam(i,e.target.value)} placeholder={'Team '+(i+1)}/>
          {teams.length>1&&<button className="pq-remove" onClick={()=>removeTeam(i)}>✕</button>}
        </div>)}
        {teams.length<8&&<button className="pq-add-btn" onClick={addTeam}>+ Add Team</button>}
      </div>
      <div>
        <div className="pq-section">Question Bank</div>
        <div className="pq-bank-grid">
          {Object.entries(BANKS).map(([k,b])=><button key={k} className={'pq-bank-btn'+(bank===k?' active':'')} onClick={()=>setBank(k)}>{b.emoji} {b.label}</button>)}
        </div>
      </div>
      <div>
        <div className="pq-section">Number of Questions</div>
        <div style={{display:'flex',gap:8}}>
          {[5,10,15,20].map(n=><button key={n} className={'pq-bank-btn'+(qCount===n?' active':'')} onClick={()=>setQCount(n)} style={{flex:1}}>{n}</button>)}
        </div>
      </div>
      <button className="btn-gold" onClick={startQuiz}>START QUIZ</button>
    </div>}
    {phase==='quiz'&&q&&<div className="pq-host-body">
      <div className="pq-q-card">
        <div className="pq-q-label">Question {qi+1} of {qs.length}</div>
        <div className="pq-q-text">{q.q}</div>
        <div className="pq-answer-reveal">
          {!revealed?<button className="pq-reveal-btn" onClick={revealAnswer}>Reveal Answer</button>:<div className="pq-answer-text">{q.a}</div>}
        </div>
      </div>
      {revealed&&<div style={{display:'flex',flexDirection:'column',gap:6}}>
        <div className="pq-section">Mark Teams</div>
        {teams.map((t,i)=>{
          const done=marked[t.name]!==undefined;
          return(<div key={i} className="pq-mark-row">
            <span className="pq-mark-name">{t.name} <span style={{color:'#facc15',fontFamily:"'Bebas Neue',sans-serif"}}>{scores[t.name]||0}</span></span>
            <button className={'pq-mark-correct'+(done?' pq-mark-done':'')} onClick={()=>!done&&mark(t.name,true)} disabled={done}>✓</button>
            <button className={'pq-mark-wrong'+(done?' pq-mark-done':'')} onClick={()=>!done&&mark(t.name,false)} disabled={done}>✗</button>
          </div>);
        })}
      </div>}
      <div className="pq-scoreboard">
        <div className="pq-score-hdr">Scoreboard</div>
        {sorted.map(([name,pts],i)=><div key={name} className="pq-score-row">
          <span className="pq-score-pos">#{i+1}</span>
          <span className="pq-score-name">{name}</span>
          <span className="pq-score-pts">{pts}</span>
        </div>)}
      </div>
      <div className="game-actions">
        <span className="remaining">{qs.length-qi-1} questions left</span>
        <button className="btn-next y" onClick={nextQ}>{qi+1>=qs.length?'Results →':'Next →'}</button>
      </div>
    </div>}
    {phase==='over'&&<div className="game-home"><div className="over-card">
      <div className="over-tag" style={{color:'#facc15',border:'1px solid #a16207'}}>QUIZ COMPLETE</div>
      <h1 className="over-h1">Final Scores</h1>
      <div className="pq-scoreboard" style={{width:'100%'}}>
        <div className="pq-score-hdr">Results</div>
        {sorted.map(([name,pts],i)=><div key={name} className="pq-score-row">
          <span className="pq-score-pos">{i===0?'🏆':i===1?'🥈':i===2?'🥉':('#'+(i+1))}</span>
          <span className="pq-score-name">{name}</span>
          <span className="pq-score-pts">{pts}</span>
        </div>)}
      </div>
      <button className="btn-gold" onClick={()=>setPhase('setup')}>New Quiz</button>
    </div></div>}
  </div>);
}
